export default __webpack_public_path__ + "static/media/01.e3756bb2.jpg";